<template>
  <b-card v-if="totalLabsCount > 0" class="mb-3" no-body>
    <b-card-header class="py-2 bg-light d-flex justify-content-between align-items-center">
      <span>
        <i class="fas fa-flask mr-2"></i>งานแลป
        <small v-if="!showAllLabs && hiddenCount > 0" class="text-muted ml-1">
          (แสดง {{ labs.length }} จาก {{ totalLabsCount }})
        </small>
      </span>
      <b-badge variant="warning">{{ labs.length }}</b-badge>
    </b-card-header>
    <b-card-body class="p-0">
      <b-table
        v-if="labs.length > 0"
        :items="labs"
        :fields="fields"
        :tbody-tr-class="rowClass"
        table-class="table-condensed"
        small
        hover
        responsive
        head-variant="light"
        class="mb-0"
      >
        <template #cell(name)="{ item }">
          {{ item.mLab?.nameTh || item.mLab?.nameEn || '-' }}
        </template>
        <template #cell(toothNo)="{ item }">
          {{ item.toothNo || '-' }}
        </template>
        <template #cell(status)="{ item }">
          <div v-if="item.isUpdating" class="text-center">
            <b-spinner small></b-spinner>
          </div>
          <b-dropdown
            v-else
            size="xs"
            :text="getStatusLabel(item.status)"
            :variant="getStatusVariant(item.status)"
            boundary="window"
          >
            <b-dropdown-item
              v-for="s in statusList"
              :key="s.value"
              @click="onStatusChange(item, s.value)"
            >{{ s.label }}</b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(creationDt)="{ item }">
          {{ formatDate(item.creationDt) }}
        </template>
      </b-table>
      <div v-else class="text-center text-muted py-2 small">
        ไม่มี lab ในช่วง ±30 วัน ของวันนัดนี้
      </div>
      <div v-if="showToggleButton" class="text-center py-1 border-top">
        <b-button size="sm" variant="link" @click="$emit('toggle-show-all')">
          <i :class="showAllLabs ? 'fas fa-compress-alt mr-1' : 'fas fa-expand-alt mr-1'"></i>
          {{ toggleLabel }}
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";
import { LAB_STATUS_LIST, getLabStatusByValue } from "@/constants/labStatus";
import moment from "moment";

export default {
  name: "LabLinkCard",
  props: {
    labs: { type: Array, default: () => [] },
    totalLabsCount: { type: Number, default: 0 },
    showAllLabs: { type: Boolean, default: false }
  },
  data() {
    return {
      statusList: LAB_STATUS_LIST,
      fields: [
        { key: "name", label: "รายการแลป", class: "narrow-spacing" },
        { key: "toothNo", label: "ซี่ฟัน", class: "narrow-spacing d-none d-md-table-cell" },
        { key: "status", label: "สถานะ", class: "narrow-spacing" },
        { key: "creationDt", label: "วันที่สร้าง", class: "narrow-spacing d-none d-lg-table-cell" }
      ]
    };
  },
  computed: {
    hiddenCount() {
      return Math.max(0, this.totalLabsCount - this.labs.length);
    },
    showToggleButton() {
      return this.showAllLabs || this.hiddenCount > 0;
    },
    toggleLabel() {
      if (this.showAllLabs) return "ซ่อน lab นอกช่วง ±30 วัน";
      return `ดู lab ทั้งหมดของคนไข้ (อีก ${this.hiddenCount} รายการ)`;
    }
  },
  methods: {
    ...mapActions({
      updateLabStatus: "moduleLab/updateLabStatus"
    }),
    formatDate(date) {
      return date ? moment(date).format("DD MMM YY") : "-";
    },
    getStatusLabel(status) {
      return getLabStatusByValue(status).label;
    },
    getStatusVariant(status) {
      return getLabStatusByValue(status).variant;
    },
    rowClass(item) {
      return item.status === 'Delivered' ? 'delivered-lab' : '';
    },
    async onStatusChange(lab, newStatus) {
      this.$set(lab, "isUpdating", true);
      try {
        await this.updateLabStatus({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          labId: lab.id,
          status: newStatus
        });
        lab.status = newStatus;
        this.$emit("statusUpdated", lab);
      } catch (err) {
        console.error("Failed to update lab status:", err);
      } finally {
        this.$set(lab, "isUpdating", false);
      }
    }
  }
};
</script>

<style>
.table-condensed {
  font-size: 0.8rem;
}
.table .delivered-lab {
  opacity: 0.6 !important;
  background-color: #f8f9fa !important;
}
.table .delivered-lab td {
  color: #6c757d !important;
}
.btn-purple {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
}
.btn-purple:hover,
.btn-purple:focus {
  background-color: #5a32a3;
  border-color: #5a32a3;
  color: #fff;
}
</style>
